export const SEED_PATIENTS_REQUEST = "SEED_PATIENTS_REQUEST";
export const SEED_PATIENTS_SUCCESS = "SEED_PATIENTS_SUCCESS";
export const SEED_PATIENTS_FAIL = "SEED_PATIENTS_FAIL";

export const SEED_SUBMIT_REQUEST = "SEED_SUBMIT_REQUEST";
export const SEED_SUBMIT_PROGRESS = "SEED_SUBMIT_PROGRESS";
export const SEED_SUBMIT_SUCCESS = "SEED_SUBMIT_SUCCESS";
export const SEED_SUBMIT_FAIL = "SEED_SUBMIT_FAIL";
export const SEED_SUBMIT_RESET = "SEED_SUBMIT_RESET";

export const SEED_LOGS_FETCH_REQUEST = "SEED_LOGS_FETCH_REQUEST";
export const SEED_LOGS_FETCH_SUCCESS = "SEED_LOGS_FETCH_SUCCESS";
export const SEED_LOGS_FETCH_FAIL = "SEED_LOGS_FETCH_FAIL";

export const SEED_REGISTRATION_SAVE_REQUEST = "SEED_REGISTRATION_SAVE_REQUEST";
export const SEED_REGISTRATION_SAVE_SUCCESS = "SEED_REGISTRATION_SAVE_SUCCESS";
export const SEED_REGISTRATION_SAVE_FAIL = "SEED_REGISTRATION_SAVE_FAIL";
export const SEED_REGISTRATION_SAVE_RESET = "SEED_REGISTRATION_SAVE_RESET";

export const SEED_DEVICE_CYCLES_REQUEST = "SEED_DEVICE_CYCLES_REQUEST";
export const SEED_DEVICE_CYCLES_SUCCESS = "SEED_DEVICE_CYCLES_SUCCESS";
export const SEED_DEVICE_CYCLES_FAIL = "SEED_DEVICE_CYCLES_FAIL";

export const SEED_BILLING_EVAL_REQUEST = "SEED_BILLING_EVAL_REQUEST";
export const SEED_BILLING_EVAL_SUCCESS = "SEED_BILLING_EVAL_SUCCESS";
export const SEED_BILLING_EVAL_FAIL = "SEED_BILLING_EVAL_FAIL";
export const SEED_BILLING_EVAL_RESET = "SEED_BILLING_EVAL_RESET";

export const SEED_WINDOW_END_SAVE_REQUEST = "SEED_WINDOW_END_SAVE_REQUEST";
export const SEED_WINDOW_END_SAVE_SUCCESS = "SEED_WINDOW_END_SAVE_SUCCESS";
export const SEED_WINDOW_END_SAVE_FAIL = "SEED_WINDOW_END_SAVE_FAIL";
export const SEED_WINDOW_END_SAVE_RESET = "SEED_WINDOW_END_SAVE_RESET";

export const PAIN_LOG_TYPE = "random_entry";

export const MAX_RANGE_DAYS = 30;

/** Inclusive device cycle window length (start … start+29). */
export const DEVICE_CYCLE_WINDOW_DAYS = 30;

/** How far back registration date can be moved when seeding (from current registration). */
export const MAX_REGISTRATION_LOOKBACK_MONTHS = 2;

export const DEFAULT_BODY_PARTS = [
  { side: "center", name: "lower back" },
  { side: "left", name: "knee" },
  { side: "right", name: "shoulder" },
];

export const QOL_QUESTIONS = [
  {
    question_text: "Mobility",
    answers: [
      "I have no problems walking",
      "I have slight problems walking",
      "I have moderate problems walking",
      "I have severe problems walking",
      "I am unable to walk",
    ],
  },
  {
    question_text: "Self-care",
    answers: [
      "I have no problems washing or dressing",
      "I have slight problems washing or dressing",
      "I have moderate problems washing or dressing",
      "I have severe problems washing or dressing",
      "I am unable to wash or dress",
    ],
  },
  {
    question_text: "Usual activities",
    answers: [
      "I have no problems doing my usual activities",
      "I have slight problems doing my usual activities",
      "I have moderate problems doing my usual activities",
      "I have severe problems doing my usual activities",
      "I am unable to do my usual activities",
    ],
  },
  {
    question_text: "Pain / discomfort",
    answers: [
      "I have no pain or discomfort",
      "I have slight pain or discomfort",
      "I have moderate pain or discomfort",
      "I have severe pain or discomfort",
      "I have extreme pain or discomfort",
    ],
  },
  {
    question_text: "Anxiety / depression",
    answers: [
      "I am not anxious or depressed",
      "I am slightly anxious or depressed",
      "I am moderately anxious or depressed",
      "I am severely anxious or depressed",
      "I am extremely anxious or depressed",
    ],
  },
];
